import { NgModule } from '@angular/core'
import { MbPaymentMethodsComponent } from './mb-payment-methods.component'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { CommonModule } from '@angular/common'
import { MbPaymentMethodsWrapperComponent } from '../mb-payment-methods-wrapper/mb-payment-methods-wrapper.component'

@NgModule({
    imports: [
      ConfigModule.withConfig({
        cmsComponents: {
          MiltenyiPaymentMethodsComponent: {
            component: MbPaymentMethodsWrapperComponent
          }
        }
      }),
        I18nModule,
        CommonModule
    ],
    providers: [],
    exports: [
        MbPaymentMethodsComponent
    ],
    declarations: [MbPaymentMethodsComponent, MbPaymentMethodsWrapperComponent]
})

export class MbPaymentMethodsModule {
}
